import React from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "../../Layout/Layout";
import ProviderProductWizard from "./ProviderProductWizard";
import ReturnPolicyEditor from "../../pageInside/returnPolicy/ReturnPolicyEditor";
import { isAuthenticated } from "../../auth";
import DropshippingInterneLayout from "../components/DropshippingInterneLayout";
import ProviderNotice from "../center/ProviderNotice";
import { elakayAutoText } from "../../pageInside/dataElakay";
import { dropshippingText } from "../i18n";
import "../seller/DropshippingIn.css";

// spec §12 -- Provider Edit Product : le MÊME wizard que Add (Categories -> Info
// -> Filters -> Sales Simulation -> Images) en mode "edit". Route persistante
// /provider/products/:id/edit : le produit est relu via GET (propriétaire vérifié
// côté serveur), donc refresh / lien direct / retour navigateur fonctionnent.
// Enregistre sur le produit EXISTANT (PATCH, même _id) -- jamais de re-création,
// donc les liens Seller <-> Provider Product restent intacts.
// Vrai Layout Elakay + sous-menu partagé, comme toutes les pages du module.
const ProviderEditProduct = ({ infoSource }) => {
  const { id } = useParams();
  const t = dropshippingText(infoSource, "providerProductWizard");
  return (
    <Layout
      infoSource={infoSource}
      titleElakay="providerEditProduct"
      SliderPunShow={false}
      loading={false}
      outOffPage={false}
      {...infoSource?.allSettings?.layout}
      showFooter={true}
    >
      <DropshippingInterneLayout infoSource={infoSource}>
        <nav className="dsi-breadcrumb" aria-label={elakayAutoText("h_c766e665183df1", "Breadcrumb")}>
          <Link to="/provider">{elakayAutoText("h_pvc_title", "Provider Center")}</Link>
          <span aria-hidden="true">›</span>
          <Link to="/provider/products">{t("t026")}</Link>
          <span aria-hidden="true">›</span>
          <span aria-current="page">{t("t139")}</span>
        </nav>
        <ProviderNotice />
        <ProviderProductWizard key={id} infoSource={infoSource} editProductId={id} />
        {/* Return / Replace rules this Provider enforces on its Dropshipping In Sellers. */}
        <ReturnPolicyEditor productId={id} token={isAuthenticated()?.token || null} mode="provider" />
      </DropshippingInterneLayout>
    </Layout>
  );
};

export default ProviderEditProduct;
